import { TeamBranding } from '@/modules/teams/classes'

const LOCAL_STORAGE_BRANDING = 'branding'

export const setBrandingLocalData = (branding: string) => {
  window.localStorage.setItem(LOCAL_STORAGE_BRANDING, branding)
}

export const getBrandingFromLocalData = (): TeamBranding|null => {
  const branding = window.localStorage.getItem(LOCAL_STORAGE_BRANDING)
  if (!branding) return null
  try {
    const parsedData = JSON.parse(branding)
    return new TeamBranding(parsedData)
  } catch (error) {
    console.error('Error parsing branding data from local storage:', error)
  }
  return null
}
